import axios from 'axios';


const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class DistroCenterService {
	async distroCenters(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL + `/DistributionCentres?Limit=${payload.limit}`,
				{
					headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
	async confirmRequest(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL +
					`/Inventory/Requests/${payload.InventoryRequestId}/Confirmations`,
				payload,
				{
					headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
	async createDistro(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/DistributionCentres`,
				payload,
				{
					headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
	async updateDistro(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.put(
				API_URL + `/DistributionCentres/${payload.id}`,
				payload.data,
				{
					headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
	async inventories(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Products/SearchAndSort`,
				payload,
				{
					headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
	async balance(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL + `/Inventory/Location/${payload.locationId}/Inventory`,
				{
					headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
	async orders(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL +
					`/Inventory/Requests?Limit=${payload.limit}&SourceLocationId=${payload.locationId}`,
				{
					headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async ordersBySubHub(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL +
					`/Inventory/Requests?Limit=${payload.limit}&RequestType=1&DestinationLocationId=${payload.locationId}`,
				{
					headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async counts(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL +
					`/Inventory/Counts?Limit=${payload.limit}&LocationId=${payload.locationId}`,
				{
					headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
}

export default new DistroCenterService();